import React from "react";
import { Col, Row, Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import isEmpty from "../../../../store/validation/is-Empty";

const CuisineInformationSection = (props) => {
  return (
    <React.Fragment>
      <Row>
        <Col
          md={6}
          lg={3}
          xs={4}
          className="pb-4"
          style={{ borderRight: "1px solid #E0E0E0" }}
        >
          <div className="d-flex align-items-center pb-2">
            <div className="f14-700 mr-1">Food Category</div>
            <NavLink
              to="/editcategoryliquortype"
              className="enIconBtnGraySmall"
            >
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_food_category.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col
          md={6}
          lg={3}
          xs={4}
          className="pb-4"
          style={{ borderRight: "1px solid #E0E0E0" }}
        >
          <div className="d-flex align-items-center pb-2">
            <div className="f14-700 mr-1">Liquor Information</div>
            <NavLink
              to="/editcategoryliquortype"
              className="enIconBtnGraySmall"
            >
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_liquor_category.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
        <Col
          md={6}
          lg={3}
          xs={4}
          className="pb-4"
          style={{ borderRight: "1px solid #E0E0E0" }}
        >
          <div className="d-flex align-items-center pb-2">
            <div className="f14-700 mr-1">Cuisines</div>
            <NavLink to="/editcuisineoffered" className="enIconBtnGraySmall">
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {!isEmpty(props.vendor) &&
              props.vendor.selected_cusine.map((data, index) => {
                return (
                  <React.Fragment key={index}>{data.title}, </React.Fragment>
                );
              })}
          </div>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col
          md={6}
          lg={3}
          xs={6}
          className="pb-4"
          style={{ borderRight: "1px solid #E0E0E0" }}
        >
          <div className="d-flex align-items-center pb-2">
            <div className="f14-700 mr-1">Personalization</div>
            <NavLink
              to="/editcategoryliquortype"
              className="enIconBtnGraySmall"
            >
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {props.vendor && props.vendor.personalizationText}
          </div>
        </Col>
        <Col
          md={6}
          lg={3}
          xs={6}
          className="pb-4"
          style={{ borderRight: "1px solid #E0E0E0" }}
        >
          <div className="d-flex align-items-center pb-2">
            <div className="f14-700 mr-1">Allergy</div>
            <NavLink
              to="/editcategoryliquortype"
              className="enIconBtnGraySmall"
            >
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {props.vendor && props.vendor.allergicInfoText}
          </div>
        </Col>
        <Col
          md={6}
          lg={3}
          xs={6}
          className="pb-4"
          style={{ borderRight: "1px solid #E0E0E0" }}
        >
          <div className="d-flex align-items-center pb-2">
            <div className="f14-700 mr-1">Nutrition</div>
            <NavLink
              to="/editcategoryliquortype"
              className="enIconBtnGraySmall"
            >
              <Image
                src={require("../../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
            </NavLink>
          </div>
          <div className="f12-400">
            {props.vendor && props.vendor.nutritionInfoText}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
export default CuisineInformationSection;
